import Icon from '../components/Icon.vue'

Icon.register({
  running: {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M272 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM113.7 317.5c7.9 17.2 20.7 32.4 38 42.6l10.7 6.3-8.8 20.5c-7.5 17.6-24.9 29.1-44.1 29.1h-77.5c-17.7 0-32-14.3-32-32s14.3-32 32-32h66.9zM384 224c17.7 0 32 14.3 32 32 0 17.7-14.3 32-32 32h-54c-18.2 0-35.1-10.6-43.1-26.9l-20.3-41.4-31.3 78.3 61.2 36.1c18.8 11.3 27.6 33.6 21.6 54.4l-31.6 101.1c-4.3 13.7-16.9 22.5-30.5 22.5-3.2 0-6.4-0.5-9.6-1.5-16.9-5.3-26.3-23.2-21-40.1l27.5-87.7-85-50.2c-27.6-16.3-38.9-50.8-26.3-80.3l37.5-87.4-14.7-4.4c-7.8-1.9-17.6 0.3-25.3 6.1l-39.7 30.4c-14 10.7-34.1 8.1-44.9-5.9-10.8-14-8.1-34.1 5.9-44.9l39.7-30.4c23.1-17.7 52.5-23.9 80.8-17.1l71.1 21.1c26.3 6.7 49.3 25.4 61.8 50.9l26.1 53.3h44z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/running.js
// module id = 1856
// module chunks = 0